export class AppInsightsImageFeedback{
    userId: string = '';
    customerNumber: string = '';
    branchCode: string = '';
    partSearchTerm: string = '';
    feedbackType: string = '';
    additionalDetails: string = '';
}
